import NosotrosHero from './components/NosotrosHero';
import HistoriaTimeline from './components/HistoriaTimeline';
import MisionVision from './components/MisionVision';
import ValoresSection from './components/ValoresSection';
import GobernanzaSection from './components/GobernanzaSection';
import AsambleaSection from './components/AsambleaSection';
import ConsejoDirectivoSection from './components/ConsejoDirectivoSection';
import DireccionGeneral from './components/DireccionGeneral';
import ComiteVigilancia from './components/ComiteVigilancia';
import ComiteElectoral from './components/ComiteElectoral';
import TransparenciaSection from './components/TransparenciaSection';
import MarcoNormativoSection from './components/MarcoNormativoSection';
import RepresentacionInternacional from './components/RepresentacionInternacional';
import CompromisoSection from './components/CompromisoSection';

export default function NosotrosPage() {
  return (
    <>
      <NosotrosHero />
      <HistoriaTimeline />
      <MisionVision />
      <ValoresSection />
      <GobernanzaSection />
      <AsambleaSection />
      <ConsejoDirectivoSection />
      <DireccionGeneral />
      <ComiteVigilancia />
      <ComiteElectoral />
      <TransparenciaSection />
      <MarcoNormativoSection />
      <RepresentacionInternacional />
      <CompromisoSection />
    </>
  );
}